import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { SolicitarAyuda } from './pages/SolicitarAyuda';
import { QuieroSerAliado } from './pages/QuieroSerAliado';
import { Donar } from './pages/Donar';
import { VenezuelaEmergencia } from './pages/VenezuelaEmergencia';
import { DonarVenezuela } from './pages/DonarVenezuela';
import { Tienda } from './pages/Tienda';
import { Gala2026 } from './pages/Gala2026';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31agnwnhawdix">
      <div className="w-full min-h-screen bg-white" data-id="element-1" data-mp="31ayqs2ygxpzt">
        <Navbar data-id="element-2" data-mp="31cjmvx0flgzs" />
        <Routes data-id="element-3" data-mp="2wk06yte9u9rt">
          <Route path="/" element={<Home data-id="element-5" data-mp="2wj8dbo48im46" />} data-id="element-4" data-mp="2wjgtppzkg9k4" />
          <Route path="/solicitar-ayuda" element={<SolicitarAyuda data-id="element-7" data-mp="28u5ysp4wd9dw" />} data-id="element-6" data-mp="2wip734ny5m5z" />
          <Route path="/quiero-ser-aliado" element={<QuieroSerAliado data-id="element-9" data-mp="28s2y9b64bxux" />} data-id="element-8" data-mp="28te3zgj4jfoo" />
          <Route path="/donar" element={<Donar data-id="element-11" data-mp="23ujlygszdv5m" />} data-id="element-10" data-mp="23vuq4hqc94x9" />
          <Route path="/venezuela-emergencia" element={<VenezuelaEmergencia data-id="element-13" data-mp="3iiwaeb4natww" />} data-id="element-12" data-mp="23v2u55stx56g" />
          <Route path="/donar-venezuela" element={<DonarVenezuela data-id="element-15" data-mp="3mkrchhuehbbq" />} data-id="element-14" data-mp="3ii4qvyobommz" />
          <Route path="/tienda" element={<Tienda data-id="element-17" data-mp="3rc9em985thya" />} data-id="element-16" data-mp="3mjzpgvevclx2" />
          <Route path="/gala-2026" element={<Gala2026 data-id="element-19" data-mp="3rdkkqfp2v1sk" />} data-id="element-18" data-mp="3rbrbcsn2y3gv" />
        </Routes>
        <Footer data-id="element-20" data-mp="5yjetptzbev" />
      </div>
    </BrowserRouter>;
}